import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as dayjs from 'dayjs';
import * as relativeTime from 'dayjs/plugin/relativeTime';
import * as utc from 'dayjs/plugin/utc';
import 'dayjs/locale/ar';

dayjs.extend(relativeTime);
dayjs.extend(utc);

@Pipe({
  name: 'timeAgo',
  standalone: true
})
export class TimeAgoPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: string | Date): string {
    if (!value) return '';

    // معالجة الصيغ غير القياسية
    let dateStr = typeof value === 'string' ? value : value.toString();
    // إذا كانت الصيغة بدون T أو Z، أضفهم
    if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(dateStr)) {
      dateStr = dateStr.replace(' ', 'T') + 'Z';
    }
    // إذا كانت الصيغة بدون Z أو توقيت، أضف Z
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(dateStr)) {
      dateStr += 'Z';
    }

    dayjs.locale(this.translateService.currentLang === 'ar' ? 'ar' : 'en');
    const d = dayjs(dateStr);
    if (!d.isValid()) {
      // إذا كان التاريخ غير صالح، أرجع التاريخ نفسه بصيغة YYYY-MM-DD
      // إذا كان التاريخ نص، أرجعه كما هو مع الاقتصار على أول 10 أحرف (YYYY-MM-DD)
      return dateStr ? dateStr.substring(0, 10) : '';
    }
    if (d.isAfter(dayjs())) return this.translateService.instant('TIME_AGO.JUST_NOW');
    if (this.translateService.currentLang === 'ar') {
      return `${this.translateService.instant('TIME_AGO.AGO')} ${d.fromNow(true)}`;
    }
    return d.fromNow();
  }
}